import React, { useEffect, useState } from 'react';
import worker from '../../assets/Images/worker.png'
import { Button } from 'antd';
import { Header } from '../../Components/index'
const Payment = ({ selectedValue }) => {
    // const [address, setAddress] = useState('')
    // let selectedValue?.val = localStorage.getItem('selected-key')
    console.log('RUN', selectedValue?.val)
    if (selectedValue?.val == '20m2-35m2') {
        console.log('SELECT', '20m2-35m2')
    } else if (selectedValue?.val == '35m2-50m2') {
        console.log('SELECT', '35m2-50m2')

    } else if (selectedValue?.val == 'Plus de 50m2') {
        console.log('SELECT', 'Plus de 50m2')
    }

    return (
        <>
            <div>
                <Header heading='Votre offre personnalisée' />
                <div className='inner_div'>
                    <div className='worker_div' >
                        <img src={worker} className='worker_img' />
                    </div>
                    <div className='section_container'>
                        {
                            selectedValue?.val == '20-35m2' ?
                                <>
                                    <div className="section  paymentSection">
                                        <div className='payment_section'>
                                            <div className='kwc_div kWC_div'>
                                                <h1 className='kwc KWC_3 '>3 kWc</h1>
                                                <p className='kwc_text Puissance'>Puissance recommandée pour votre installation</p>
                                            </div>
                                            <div className='kwc_div '>
                                                <h1 className='kwc ProduitsKWC '>1 290 €</h1>
                                                <p className='kwc_text '>Prime à l’autoconsommation</p>
                                            </div>
                                            <div className='kwc_div'>
                                                <h1 className='kwc'>3488 kWh</h1>
                                                <p className='kwc_text  '>Produits par votre installation</p>
                                            </div>
                                            <div className='green_kwc_div'>
                                                <h1 className='green_kwc'>21137 €*</h1>
                                                <p className='sur'>d’économies sur 25ans</p>
                                                {/* <p>*Ce chiffre est une estimation et ne peut etre utiliser comme valeur de référence </p> */}
                                            </div>
                                            <p className='chiffre'>*Ce chiffre est une estimation et ne peut etre utiliser comme valeur de référence </p>
                                            <div className='kwc_btn_div'>
                                                <Button onClick={() => window.open('https://www.solarone.fr/booking/')} className='kwc_btn'>Prendre rendez-vous</Button>
                                            </div>
                                        </div>
                                    </div>
                                </> : null
                        }
                        {
                            selectedValue?.val == '35-50m2' ?
                                <>
                                    <div className="section  paymentSection">
                                        <div className='payment_section'>
                                            <div className='kwc_div kWC_div'>
                                                <h1 className='kwc KWC_6'>6 kWc</h1>
                                                <p className='kwc_text Puissance'>Puissance recommandée pour votre installation</p>
                                            </div>
                                            <div className='kwc_div'>
                                                <h1 className='kwc ProduitsKWC '>1 290 €</h1>
                                                <p className='kwc_text '>Prime à l’autoconsommation</p>
                                            </div>
                                            <div className='kwc_div'>
                                                <h1 className='kwc'>6392 kWh</h1>
                                                <p className='kwc_text'>Produits par votre installation</p>
                                            </div>
                                            <div className='green_kwc_div'>
                                                <h1 className='green_kwc'>30925 €*</h1>
                                                <p className='sur'>d’économies sur 25ans</p>
                                            </div>
                                            <p className='chiffre'>*Ce chiffre est une estimation et ne peut etre utiliser comme valeur de référence </p>
                                            <div className='kwc_btn_div'>
                                                <Button onClick={() => window.open('https://www.solarone.fr/booking/')} className='kwc_btn'>Prendre rendez-vous</Button>
                                            </div>
                                        </div>
                                    </div>
                                </> : null
                        }

                        {
                            selectedValue?.val == 'Plus de 50m2' ?
                                <>
                                    <div className="section  paymentSection">
                                        <div className='payment_section'>
                                            <div className='kwc_div'>
                                                <h1 className='kwc KWC_6'>12 kWc</h1>
                                                <p className='kwc_text Puissance'>Puissance recommandée pour votre installation</p>
                                            </div>
                                            <div className='kwc_div'>
                                                <h1 className='kwc ProduitsKWC'>1 290 €</h1>
                                                <p className='kwc_text'>Prime à l’autoconsommation</p>
                                            </div>
                                            <div className='kwc_div'>
                                                <h1 className='kwc'>9808 kWh</h1>
                                                <p className='kwc_text'>Produits par votre installation</p>
                                            </div>
                                            <div className='green_kwc_div'>
                                                <h1 className='green_kwc'>49925 €*</h1>
                                                <p className='sur'>d’économies sur 25ans</p>
                                            </div>
                                            <p className='chiffre'>*Ce chiffre est une estimation et ne peut etre utiliser comme valeur de référence </p>
                                            <div className='kwc_btn_div'>
                                                <Button onClick={() => window.open('https://www.solarone.fr/booking/')} className='kwc_btn'>Prendre rendez-vous</Button>
                                            </div>
                                        </div>
                                    </div>
                                </> : null
                        }
                    </div>
                </div>
            </div>
        </>
    )
}
export default Payment